export enum objectModelPrerequisiteType {
  ConditionalRule = 1,
  RelativeDate = 2
}

export const objectModelPrerequisiteTypeName = {
  [objectModelPrerequisiteType.ConditionalRule]: 'Conditional Prerequisite',
  [objectModelPrerequisiteType.RelativeDate]: 'Relative Date Prerequisite',

};